
  <template>
	 <div class="quotation-details-container"> 
		<div class="quotation-header">
			 <div class="container"> 
			<div class="header-content"> <div class="header-title-section">
				 <h1 class="page-title">Recommendation Details</h1> 
				 <p class="page-subtitle"> Review the details of your selected insurance recommendation </p> 
				</div> </div> </div> </div> 
				<div class="main-content"> 
					<div class="lg:w-3/4 w-full mx-auto"> <div v-if="review">
					 <div class="content-grid"> <div class="summary-card">
						 <div class="card-content"> <div class="summary-header"> 
							<h2 class="section-title"> Recommendation Summary </h2> 
							<div class="status-badge" :class="getStatusClass(review.status)" > 
								<i class="status-icon" :class=" getStatusIcon(review.status) " ></i> {{ review.status }} </div> 
							</div>
								 <div class="summary-details"> <div class="detail-grid">
									 <div class="detail-item">
									 <div class="detail-label"> 
									<i class="fas fa-calendar-alt detail-icon" ></i> Vehicle Value </div> 
									<div class="detail-valu font-bold float-left" > KES {{ review.riskValue }}
										 </div> </div> <div class="detail-item">
										 <div class="detail-label">
											 <i class="fas fa-calendar-alt detail-icon" >

										 </i> Vehicle Registration </div> 
										 <!-- <div class="detail-valu font-bold float-left">{{review.riskDetails.regNo }}</div> --> </div> 
										  <div class="detail-item"> <div class="detail-label"> <i class="fas fa-user-tie detail-icon" ></i> Intermediary </div> <!-- <div class="detail-value">{{ intermediaryName }}</div> --> </div> </div> <div v-if="review.remarks" class="remarks-section" > <div class="detail-label"> <i class="fas fa-comment-alt detail-icon" ></i> Remarks </div> 
										  <div class="remarks-content"> {{ review.remarks }} </div> </div> </div> <!-- <div class="summary-actions"> <button v-if=" review.status.toLowerCase() == 'accepted' " @click=" acceptReccomendationReview(review) " class="btn btn-primary accept-btn" > <i class="fas fa-check"></i> Accept Recommendation </button> </div> --> </div>
										 </div> 
							<div class="right-column-wrapper"> <div class="product-details-card"> 
								<div class="card-content"> <h2 class="section-title"> Product Details </h2> 
									<div class="product-grid"> <div class="product-image"> 
										<img :src=" review.product.productLogo " alt="Product Image" class="profile-img" /> 
									</div> <div class="product-info"> <div class="detail-item"> 
										<div class="detail-label"> Product Name </div> <div class="detail-value"> {{ review.product .productName }} </div> 
									</div> <div class="detail-item"> <div class="detail-label">
										 Premium 

									</div> 
									<div class="detail-value"> {{ review.premiumAmount }} </div> 
								</div> 
									<div class="detail-item"> <div class="detail-label">
										 Recommendation Level
										
									</div> 
									<div class="star-rating"> <i v-for="n in review.reccommendationLevel" :key="'filled-' + n" class="fas fa-star filled" ></i> <i v-for="n in 5 - review.reccommendationLevel" :key="'empty-' + n" class="fas fa-star empty" ></i> <span class="level-text">{{ getLevelText( review.reccommendationLevel, ) }}</span>
									</div> </div> </div>
								 </div> </div> 
								</div> 
								<div class="bg-white rounded-xl shadow-sm overflow-hidden">
  <div class="bg-gray-50 px-6 py-4">
    <h2 class="text-2xl font-bold text-primary flex items-center">
      <svg class="w-7 h-7 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
      Client Details
    </h2>
  </div>

  <div class="p-6">
    <dl class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      <!-- Vehicle Value -->
      <div class="flex flex-col bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition">
        <dt class="text-sm font-medium text-gray-500 flex items-center mb-2">
          <svg class="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Vehicle Value
        </dt>
        <dd class="text-lg font-semibold text-gray-900">
          {{ review.riskValue | currency }} <!-- Optional: add currency filter if needed -->
        </dd>
      </div>

      <!-- Name -->
      <div class="flex flex-col bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition">
        <dt class="text-sm font-medium text-gray-500 flex items-center mb-2">
          <svg class="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          Full Name
        </dt>
        <dd class="text-lg font-semibold text-gray-900">
          {{ review.clientDetails.firstName }} {{ review.clientDetails.lastName }}
        </dd>
      </div>

      <!-- KRA Pin -->
      <div class="flex flex-col bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition">
        <dt class="text-sm font-medium text-gray-500 flex items-center mb-2">
          <svg class="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          KRA PIN
        </dt>
        <dd class="text-sm font-semibold text-gray-900">
          {{ review.clientDetails.kraPin }}
        </dd>
      </div>

      <!-- Email -->
      <div class="flex flex-col bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition">
        <dt class="text-sm font-medium text-gray-500 flex items-center mb-2">
          <svg class="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          Email
        </dt>
        <dd class="text-sm font-semibold text-gray-900">
          {{ review.clientDetails.email }}
        </dd>
      </div>
    </dl>
  </div>
</div>
							<div class="benefits-and-premium-card bg-white rounded-2xl shadow-sm overflow-hidden" > 
								<div class="card-content p-6 lg:p-8"> 
									<!-- Benefits Section -->
									 <div class="benefits-section mb-5">
										 <div class="section-header mb-4"> 
											<h2 class="text-2xl font-bold text-gray-900" > Benefits </h2>
											 <p class="text-gray-600 mt-2"> Customize your coverage with embedded and optional benefits </p> </div> <!-- Desktop Table --> 
											 <div class="hidden lg:block overflow-x-auto rounded-xl border border-gray-200" > <table class="w-full table-auto"> 
												<thead class="bg-gray-50 border-b border-gray-200" > <tr> 
												<th class="px-3 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" > Type </th>
												 <th class="px-3 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" > 
												Benefit Details </th> 
												<th class="px-6 py-2 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" > Limit </th>
												 <th class="px-6 py-2 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" > Action </th> 
												</tr> 
											</thead> 
												<tbody class="bg-white divide-y divide-gray-200" > <tr v-for="benefit in review .product .productBenefits" :key=" benefit.benefitSystemRef " class="hover:bg-gray-50 transition" > 
													<td class="px-3 py-2"> <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium" :class=" getBenefitType( benefit, ) === 'embedded' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800' " > {{ getBenefitType( benefit, ) }} </span> </td>
													 <td class="px-3 py-2"> <div class="text-sm font-medium text-gray-900" > {{ getBenefitName( benefit, ) }} </div> <div class="text-sm text-gray-500 mt-1" > {{ getBenefitDescription( benefit, ) }} 

													 </div> </td> <td class="px-3 py-2" > <input type="number" :disabled="!benefit.benefitLimit.isAdjustable" :value=" getBenefitLimit( benefit, ) " @input=" updateBenefitLimit( benefit, $event .target .value, ) " :min=" benefit .benefitLimit .minimum " :max=" benefit .benefitLimit .maximum " placeholder="Enter limit" class="w-32 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" /> </td> <td class="px-6 py-5"> 
														<button @click=" saveBenefit( benefit, ) " v-if="benefit.benefitType=='optional' ||benefit.benefitLimit.isAdjustable" class="inline-flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white font-medium text-sm rounded-lg shadow-sm transition transform hover:scale-105" > 
														<svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" > <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /> </svg> 
														<span v-if="isSaving(benefit)">Saving...</span>
  														<span v-else>Save</span>
													</button>
													 </td>
													 </tr> 
													</tbody> 
													</table> 
												</div> <!-- Mobile View -->
													 <div class="lg:hidden space-y-5"> 
														<div v-for="benefit in review.product.productBenefits" :key="benefit.benefitSystemRef" class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" > 
												<div class="flex justify-between items-start mb-3" > 
													<div v-if="benefit.benefitLimit.isAjustable">
														 <h4 class="font-semibold text-gray-900" > {{ getBenefitName( benefit, ) }} </h4> 
													<p class="text-sm text-gray-600 mt-1" > {{ getBenefitDescription( benefit, ) }} </p> 
												</div> <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium" :class=" getBenefitType( benefit, ) === 'embedded' ? 'bg-blue-100 text-blue-800' : 'bg-amber-100 text-amber-800' " > {{ getBenefitType( benefit, ) }} </span> </div> <div class="mt-4" v-if="benefit.benefitLimit.isAjustable"> <label class="block text-sm font-medium text-gray-700 mb-1" >Set Limit</label > <input type="number" :value=" getBenefitLimit( benefit, ) " @input=" updateBenefitLimit( benefit, $event.target .value, ) " :min=" benefit.benefitLimit .minimum " :max=" benefit.benefitLimit .maximum " class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500" /> </div>
														 <button @click=" saveBenefit(benefit) " v-if="benefit.benfitType=='optional'" class="mt-4 w-full py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition" >
															Save Benefit </button> </div> </div> 
															<!-- Added Benefits --> 
														<div class="mt-5"> 
															<h3 class="text-lg font-semibold text-gray-800 mb-2" > Added Benefits </h3>
															 <div v-if=" selectedBenefits.length === 0 " class="text-center py-4 text-gray-900" > 
																<p> No additional benefits added yet. </p> </div>
																 <div v-for="ben in selectedBenefits" :key=" ben.benefit.benefitSystemRef " class="bg-gradient-to-r h-fit from-blue-50 to-indigo-50 rounded-xl p-5 mb-4 border border-blue-100" >
																	 <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" > 
																		<div class="flex-1"> <button @click=" deleteBenefit( ben.benefit, ) " class="text-xs text-red-700" > delete </button> <h4 class="text-md font-semibold text-gray-900" > {{ ben.benefit .benefit_category_name }} </h4> <p class="text-sm text-gray-600 mt-1" > Current Limit: <span class="font-medium" >{{ ( ben.limit || 0 ).toLocaleString() }}</span > </p> </div> <div class="flex items-center gap-3" v-if="ben.benefit.benefitLimit.isAjustable" > <input type="number" :value="ben.limit" @input=" ben.limit = Number( $event .target .value, ); calculatePremiums(); " :min=" ben.benefit .benefitLimit .minimum " :max=" ben.benefit .benefitLimit .maximum " class="w-40 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500" placeholder="Adjust limit" /> 
														<button @click=" adjustBenefit( ben, ) " class="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg shadow transition" > Adjust </button> 
													</div> 
												</div>
												 </div> 
												</div> 
											</div>
													 <div class="px-6 py-5 space-y-6"> 
														<div> <h5 class="text-base font-medium text-gray-900"> Product Charges </h5>
															 <div class="mt-4 space-y-4" v-if="selectedQuotationReview.product.productCharges"">
																<div v-for="charge in selectedQuotationReview.product.productCharges" :key="charge.charge_name" class="flex items-center justify-between py-3 border-b border-gray-100 last:border-b-0" >
																	 <div class="flex-1"> <span class="text-sm font-medium text-gray-600" >Name</span >
																		 <p class="text-base text-gray-900"> {{ charge.charge_name }} </p> 
																		</div> <div class="flex-1 text-right"> 
																			<span class="text-sm font-medium text-gray-600" >Amount</span >
																				 <p class="text-base font-semibold text-gray-900" > 
																					{{ Math.round(calculateChargeAmount(charge))}} </p> 
																				</div> 
																			</div> 
																				</div> 
																			</div> <!-- Total Charges --> 
																			<div class="flex items-center justify-between pt-4">
																				 <h5 class="text-base font-medium text-gray-900"> Total Charges </h5>
																				  <p class="text-lg font-bold text-gray-900" v-if="selectCalculatedQuote"> <!-- {{ getTotalCharges() }} --> {{ Math.round(reccomendation.premium.totalCharges).toLocaleString() }} 

														</p> 
														<!-- <p class="text-lg font-bold text-gray-900" v-else> 
															{{ getTotalCharges() }} 

															</p>  -->
													</div> 
													</div>
													 <div>
														 <button @click="calculatePremium" class="bg-black text-white w-fit p-2 rounded-lg"> 
															<span v-if="!iscalculating">Save Changes</span> <span v-if="iscalculating" class="animate-pulse">Saving....</span>
														</button> </div> <!---Calculation Creteria--> <div class="mb-6 sm:mb-8 mt-6 sm:mt-8"> <!-- Header with Toggle Button --> <button class="w-full bg-white hover:bg-blue-50 rounded-xl px-4 sm:px-6 py-4 transition-all duration-200 flex items-center justify-between text-base sm:text-lg font-semibold text-slate-800 cursor-pointer select-none shadow-sm border border-blue-100 hover:border-blue-200 group" @click="showCriteria = !showCriteria" type="button" :aria-expanded="showCriteria" aria-controls="criteria-content" > <div class="flex items-center gap-3"> <div class="w-9 h-9 sm:w-10 sm:h-10 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition-colors">
														 <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"> <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" /> </svg> </div> <span>View Calculation Criteria</span> </div> <!-- Chevron Icon -->
														 <svg class="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 transition-transform duration-300 flex-shrink-0" :class="{ 'rotate-180': showCriteria }" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" > <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="currentColor" /> </svg>
														 </button> <!-- Collapsible Content -->
													  <transition name="fade-slide"> 
														<section v-if="showCriteria" id="criteria-content" class="mt-4 bg-gradient-to-br from-blue-50 to-white rounded-xl p-4 sm:p-6 border border-blue-100 shadow-sm" > <div class="space-y-3"> <div v-for="(logic, index) in selectCalculatedQuote.calculationLogic || []" :key="index" class="flex items-start gap-3 p-4 bg-white rounded-lg border border-blue-100 hover:border-blue-200 transition-colors" >
														<div class="flex-shrink-0 mt-0.5">
														 <div class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center">
														 <span class="text-xs font-bold text-blue-700">{{ index + 1 }}</span> 
													</div> </div> <p class="text-sm sm:text-base text-slate-700 leading-relaxed flex-1"> {{ logic }} </p> 
												</div> <!-- Fallback if no logic available -->
													 <div v-if="!selectCalculatedQuote.calculationLogic || !selectCalculatedQuote.calculationLogic.length" class="flex flex-col items-center justify-center py-8 text-center" > 
														<div class="w-14 h-14 sm:w-16 sm:h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4"> <svg class="w-7 h-7 sm:w-8 sm:h-8 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"> <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /> </svg> </div> <p class="text-sm font-medium text-slate-500">No calculation criteria available</p>
													 <p class="text-xs text-slate-400 mt-1">Criteria will appear here once processed</p> 
													</div>
													 </div> </section> 
													</transition> </div> <!-- Premium Summary -->
													  <div class="premium-summary-section bg-gradient-to-br from-blue-50 to-indigo-100 rounded-2xl p-6 border border-blue-200" > 
														<h2 class="text-2xl font-bold text-gray-900 mb-6" > Premium Summary </h2> 
														<div class="space-y-4 text-lg">
														 <div class="flex justify-between"> <span class="text-gray-700" >Base Premium</span >
															 <span class="font-semibold">{{ Math.round(reccomendation.premium.basePremium).toLocaleString() }} </span> 
															</div> <div class="flex justify-between"> <span class="text-gray-700">Additional Premium</span> 
																<span class="font-semibold text-green-600"> {{ Math.round(reccomendation.premium.additionalPremium).toLocaleString() }} </span> 
															</div>
															 <hr class="border-gray-300" /> 
															 <div class="flex justify-between text-xl" > 
																<span class="font-bold text-gray-900" >Total Premium</span > 
																	<span class="font-bold text-indigo-700" > {{ Math.round(reccomendation.premium.totalPremium).toLocaleString() }} </span > 
																	</div> 
																</div> 
															</div> 
																	</div>
																 </div> 
																
											  <!-- <div class="navigation-actions"> <button class="btn btn-primary next-btn" @click="viewRecommendation(selectedClientRecommendation.guest_client_quotation_recommendation_ref)" :disabled="isAnimating" :class="{ 'is-animating': isAnimating }" > <span v-if="!isAnimating"> Next <i class="fas fa-arrow-right ms-2"></i> </span> <span v-else> Redirecting <i class="fas fa-spinner fa-spin ms-2"></i> </span> </button> </div> --> <div class="float-end"> <button v-if=" review.status.toLowerCase() == 'accepted' " @click=" acceptReccomendationReview(review) " class=" bg-green-700 text-white p-2.5 w-1/2 rounded-lg accept-btn" > <i class="fas fa-check"></i> Proceed </button> </div> </div> </div> </div> <div v-else class="loading-state"> <div class="loading-spinner"> <div class="spinner"></div> </div> <p class="loading-text"> Loading recommendation details... </p> 
														</div> 
														</div>
														 </div> 
													</div> 
														</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { AcceptReccommendation, CompleteQuotation } from '../../api/insurance';
import {  calaculateProductPremium  } from '@nana-tec/insurance';
export default {
	name: 'QuotationDetails',

	data() {
		return {
			benefitLimits: {},
			calculationResult:{},
			showCriteria: false,
			iscalculating:false,
			savingBenefit:{}
		};
	},
	computed: {
		...mapGetters('quotation', ['selectedQuotationReview','selectCalculatedQuote','selectQuotationResults']),
		...mapGetters('auth', ['isAuthenticated']),
		...mapGetters('benefits', ['selectedBenefits']),
		...mapGetters('product', [
			'selectedProduct',
			'selectedCoverType',
			'getProductCharges',
		]),

		review() {
			return this.selectedQuotationReview;
		},
		reccomendation(){
			return this.selectQuotationResults[0].reccommendations[0]
		}
	},
	watch: {
		selectedClientRecommendation: {
			handler(newRecommendation) {
				if (newRecommendation && newRecommendation.product) {
					this.initializeBenefits(
						newRecommendation.product.productBenefits,
					);
				}
			},
			immediate: true,
		},
	},

	methods: {
		...mapActions('clientQuotationDetails', [
			'viewClientRecommendation',
			'acceptClientRecommendation',
			'saveBenefitSelections',
			'savePremiumCalculations',
		]),
		...mapActions('quotation', [
			'setSelectedQuotationReview',
			'setSystemQuotationRef',
			'setQuotationData',
			'setQuotationResults',
			'setInvoiceRef',
			'setCalculatedQuotation'
		]),
		...mapActions('auth', ['setPurchaseType']),
		...mapActions('risk', ['setKycData']),
		...mapActions('productType', ['setProduct']),
		...mapActions('benefits', [
			'setBenefitsData',
			'updateSelectedBenefit',
			'removeBenefit',
		]),
		isSaving(benefit) {
    return !!this.savingBenefit[benefit.benefitSystemRef];
  },
  calculateChargeAmount(charge){
	let chargeAmount=0
	if(charge.charge_type=='Percentage'){
chargeAmount= (charge.value*this.selectedQuotationReview.premiumAmount) /100
	}else{
		chargeAmount= charge.value
	}

	return chargeAmount

  },
  getTotalCharges() {
			let totalCharges = 0;
			if (!this.getProductCharges || this.getProductCharges === 0) {
				totalCharges = 0;
			} else {
				totalCharges = this.getProductCharges.reduce(
					(total, charge) => total + this.calculateChargeAmount(charge),
					0,
				);
			}

			const totalBenefits = this.selectedBenefits.reduce(
				(total, ben) => total + ben.limit,
				0,
			);
			return totalCharges;
		},
		getBenefitCalculation() {
  
  if (!this.selectedQuotationReview) {
    console.warn('selectedProduct is not available yet');
    return null;
  }

//   if (!this.selectedQuotationReview.premiumAmount) {
//     console.warn('basePremiumRate is missing on selectedProduct');
//     return null;
//   }

//   if (!this.selectedBenefits || this.selectedBenefits.length === 0) {
//     console.warn('No benefits selected');
//     return null;
//   }

  if (!this.selectedQuotationReview.riskValue) {
    console.warn('Vehicle value (sum insured) is required');
    return null;
  }
const clientBenefits= this.selectedBenefits.map((ben)=>{
	const benefitInternaleRef=ben.benefit.benefitInternaleRef
	const limit=ben.limit
	return {benefitInternaleRef, limit}
})
 
  const benefitStruct = [
	   ...clientBenefits
  ]

  
  const charges = (this.selectedQuotationReview.product.productCharges || []).map(charge => ({
    charge_code: charge.charge_code || charge.chargeCode,
    chargeRate: {
      rateType: charge.charge_type || charge.rateType || 'FIXED',
      rateValue: Number(charge.value || charge.rateValue || 0),
    },
	charge_type:charge.charge_type,
	value:charge.value,
	charge_name:charge.charge_name
  }));

  
  const premiumDetails = {
    risk: {
		riskType:"ASSET",
      sumInsured: Number(this.selectedQuotationReview.riskValue),
    },
    productDetails: {
      productBaseRate:{
		rateType:this.selectedQuotationReview.product.basePremiumRate.rateType,
		rateValue:this.selectedQuotationReview.product.basePremiumRate.value
	  } ,
      charges,
      benefits: this.selectedQuotationReview.product.productBenefits || [],
    //   excessConfig: this.selectedProduct.productExcess || null,
    },
    benefits: benefitStruct,
    excessValue: 0,
  };

  console.log('Premium calculation payload:', premiumDetails);

  try {
    const result = calaculateProductPremium(premiumDetails); 
	this.setCalculatedQuotation(result)
	this.calculationResult=result
	Event.$emit('notifications:show', {
					type: 'success',
					title: 'Quotation Updated',
					message:
						'',
					duration: 3000,
				});
	console.log("===CALCULTED PREMIUM", result)
    return result;
  } catch (error) {
    console.error('Error calculating premium:', error);
    Event.$emit('notifications:show', {
      type: 'error',
      title: 'Calculation Failed',
      message: 'Failed to calculate premium. Please try again.',
      duration: 5000,
    });
    return null;
  }
},
async calculatePremium() {
	this.iscalculating=true
	try{
		await new Promise((resolve) =>setTimeout(resolve, 2000))
this.getBenefitCalculation()
Event.$emit('notifications:show', {
					type: 'success',
					title: 'Saved',
					message: 'Changes saved successfully',
					duration: 3000,
				});
	}catch(error){

	}finally{
		this.iscalculating=false
	}


},

		deleteBenefit(benefit) {
			return this.removeBenefit(benefit.benefitSystemRef);
		},

		getBenefitLimit(benefit) {
			const ref = benefit.benefitSystemRef;
			const saved = this.benefitLimits[ref];
			if (saved !== undefined) return saved;
			return (
				benefit.benefitLimit.default ||
				benefit.benefitLimit.minimum ||
				0
			);
		},

		// Update limit + trigger premium recalc
		updateBenefitLimit(benefit, value) {
			const ref = benefit.benefitSystemRef;
			const numValue = value === '' ? null : Number(value);

			if (numValue === null) {
				this.$delete(this.benefitLimits, ref);
			} else {
				this.$set(this.benefitLimits, ref, numValue);
			}

			this.calculatePremiums();
		},

		async saveBenefit(benefit) {
			const ref = benefit.benefitSystemRef;
			const id = benefit.benefitSystemRef;
			const limit = this.getBenefitLimit(benefit);
			this.$set(this.savingBenefit, ref, true);
			//check if benefit exists
			try{
				await new Promise((resolve)=>setTimeout(resolve, 1000))
			const alreadySelected = this.selectedBenefits.find(
				(b) => b.benefit.benefitSystemRef === id,
			);

			if (alreadySelected) {
				alreadySelected.limit = limit;

				this.updateSelectedBenefit({
					benefit: benefit,
					limit: limit,
				});
			} else {
				const payload = {
					benefit: benefit,
					limit: limit,
				};
				this.setBenefitsData(payload);
				Event.$emit('notifications:show', {
					type: 'success',
					title: 'Benefit saved!',
					message:
						'',
					duration: 3000,
				});
			}
			Event.$emit('notifications:show', {
					type: 'success',
					title: 'Benefit saved!',
					message:
						'',
					duration: 3000,
				});
			}catch(error){

			}finally{
				this.$delete(this.savingBenefit, ref);
			}
			
			

			
		},

		// Adjust added benefit
		adjustBenefit(selectedBen) {
			// selectedBen already has .limit (reactive)
			this.updateSelectedBenefit({
				benefit: selectedBen.benefit,
				limit: selectedBen.limit,
			});
			this.calculatePremiums();
		},
		async acceptReccomendationReview(recommendation) {
			try {
				const payload = {
					reccommendationSystemRef:
						recommendation.reccommendationSystemRef,
				};

				const response = await AcceptReccommendation(payload);

				if (!response.status) {
					throw new Error('Recommendation acceptance failed');
				}

				const systemQuotationRef =
					response.data.value._value.systemQuotationRef || null;

				// Set Vuex / state data
				this.setSelectedQuotationReview(recommendation);
				this.setSystemQuotationRef(systemQuotationRef);
				this.setProduct(recommendation.product);
				this.setKycData(recommendation.clientDetails);
				this.calculatePremium()

				Event.$emit('notifications:show', {
					type: 'success',
					title: 'Quotation Accepted',
					message:
						'The Recommendation has been accepted successfully',
					duration: 3000,
				});

				if (this.isAuthenticated) {
					const ref = { systemQuotationRef };

					const quotationData = {
						coverType: 'comprehensive',
						period: recommendation.coverDetails.period || '',
						totalPremium: recommendation.premiumAmount,
						vehicleValue: recommendation.riskValue,
					};

					const res = await CompleteQuotation(ref);

					if (res.status) {
						this.setQuotationData(quotationData);
						this.setInvoiceRef(res.data.invoiceSystemRef);
						this.$router.push(
							'/motor/payment-confirmation/payment',
						);
					}
				} else {
					this.setPurchaseType('recommendation');
					this.$router.push('/insurance/auth');
				}
			} catch (err) {
				const errorMessage =
					err.response.data.errors ||
					err.response.data.message ||
					'Failed to accept quotation';

				Event.$emit('notifications:show', {
					type: 'error',
					title: 'Quotation Error',
					message: `${errorMessage}. Please try again`,
					duration: 3000,
				});
			}
		},

		formatDate(date) {
			if (!date) return 'N/A';
			try {
				return new Intl.DateTimeFormat('en-KE', {
					dateStyle: 'medium',
				}).format(new Date(date));
			} catch (error) {
				console.error('Date formatting error:', error);
				return 'Invalid Date';
			}
		},

		formatCurrency(value, currency) {
			if (typeof value !== 'number') return 'N/A';
			const formatter = new Intl.NumberFormat('en-KE', {
				style: 'currency',
				currency: currency,
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
			return formatter.format(value);
		},

		getStatusClass(status) {
			return {
				'status-accepted':
					status && status.toLowerCase() === 'accepted',
				'status-pending': status && status.toLowerCase() === 'pending',
			};
		},

		getStatusIcon(status) {
			return {
				'fas fa-check-circle':
					status && status.toLowerCase() === 'accepted',
				'fas fa-hourglass-half':
					status && status.toLowerCase() === 'pending',
			};
		},

		getLevelText(level) {
			const levels = ['Poor', 'Fair', 'Good', 'Very Good', 'Excellent'];
			return levels[level - 1] || 'N/A';
		},

		getBenefitName(benefit) {
			return (
				(benefit && benefit.benefit_category_name) || 'Unnamed Benefit'
			);
		},

		getBenefitDescription(benefit) {
			return (
				(benefit && benefit.benefit_category_description) ||
				'No description available.'
			);
		},
		getBenefitType(benefit) {
			return (
				(benefit && benefit.benefitType) || 'No description available.'
			);
		},

		//     calculateBenefitPremium() {
		//   return this.selectedBenefits.reduce((total, b) => {
		//     const limit = parseFloat(b.limit) || 0;
		//     return total + limit;
		//   }, 0);
		// },
		calculateBenefitPremium() {
			const totalAmount = this.selectedBenefits.reduce((total, b) => {
				return total + (b.limit || 0);
			}, 0);
			return totalAmount;
		},

		calculateTotalPremium() {
			const basePremium = this.review ? this.review.premiumAmount : 0;

			return basePremium + this.calculateBenefitPremium();
		},

		calculatePremiums() {
			const total = this.selectedBenefits.reduce(total, premium);
		},

		toggleOptionalBenefit(benefitId) {
			if (!this.selectedOptionalBenefits[benefitId]) {
				this.optionalBenefitValues[benefitId].free_limit = 0;
			} else {
				const benefit = this.optionalBenefits.find(
					(b) => b.product_benefit_id === benefitId,
				);
				if (benefit) {
					this.optionalBenefitValues[benefitId].free_limit =
						benefit.free_limit || 0;
				}
			}
		},

		async acceptReccomendationReview(recommendation) {
			try {
				const payload = {
					reccommendationSystemRef:
						recommendation.reccommendationSystemRef,
				};

				const response = await AcceptReccommendation(payload);

				if (!response.status) {
					throw new Error('Recommendation acceptance failed');
				}

				const systemQuotationRef =
					response.data.value._value.systemQuotationRef || null;

				// Set Vuex / state data
				this.setSelectedQuotationReview(recommendation);
				this.setSystemQuotationRef(systemQuotationRef);
				this.setProduct(recommendation.product);
				this.setKycData(recommendation.clientDetails);

				Event.$emit('notifications:show', {
					type: 'success',
					title: 'Quotation Accepted',
					message:
						'The Recommendation has been accepted successfully',
					duration: 3000,
				});

				if (this.isAuthenticated) {
					const ref = { systemQuotationRef };

					const quotationData = {
						coverType: 'comprehensive',
						period: recommendation.coverDetails.period || '',
						totalPremium: recommendation.premiumAmount,
						vehicleValue: recommendation.riskValue,
					};

					const res = await CompleteQuotation(ref);

					if (res.status) {
						this.setQuotationData(quotationData);
						this.setInvoiceRef(res.data.invoiceSystemRef);
						this.$router.push(
							'/motor/payment-confirmation/payment',
						);
					}
				} else {
					this.setPurchaseType('recommendation');
					this.$router.push('/insurance/auth');
				}
			} catch (err) {
				const errorMessage =
					err.response.data.errors ||
					err.message ||
					'Failed to complete quotation';

				Event.$emit('notifications:show', {
					type: 'error',
					title: 'Quotation Error',
					message: `${errorMessage}. Please try again`,
					duration: 3000,
				});
			}
		},

		collectBenefitData() {
			const selectedBenefits = [
				...this.embeddedBenefits.map((b) => ({
					...b,
					selected: true,
					free_limit:
						this.benefitValues[b.product_benefit_id].free_limit,
				})),
				...this.optionalBenefits
					.filter(
						(b) =>
							this.selectedOptionalBenefits[b.product_benefit_id],
					)
					.map((b) => ({
						...b,
						selected: true,
						free_limit:
							this.optionalBenefitValues[b.product_benefit_id]
								.free_limit,
					})),
			];

			return selectedBenefits;
		},

		collectPremiumData() {
			return {
				basePremium: this.review.premiumAmount,
				additionalPremium: this.calculateOptionalPremium(),
				totalPremium: this.calculateTotalPremium(),
				// currency: this.selectedClientRecommendation.preferred_currency
			};
		},

		async saveChanges() {
			this.iscalculating=true
			try {
				await new Promise((resolve)=>setTimeout(resolve, 2000))
				const benefitData = this.collectBenefitData();
				const premiumData = this.collectPremiumData();
				await this.saveBenefitSelections(benefitData);
				await this.savePremiumCalculations(premiumData);
console.log("calculating..", this.iscalculating)
				
			} catch (error) {
				Event.$emit('notifications:show', {
					type: 'error',
					title: 'Save Error',
					message: 'Failed to save changes',
					duration: 3000,
				});
			}finally{
				this.iscalculating=false
			}
		},

		async viewRecommendation(ref) {
			if (this.isAnimating) return;
			this.isAnimating = true;

			try {
				const benefitData = this.collectBenefitData();
				const premiumData = this.collectPremiumData();

				await this.saveBenefitSelections(benefitData);
				await this.savePremiumCalculations(premiumData);

				this.$router.push({
					name: 'QuotationSummary',
					params: { id: ref },
				});
			} catch (error) {
				console.error(
					'Error saving benefit data or navigating:',
					error,
				);
				this.isAnimating = false;

				Event.$emit('notifications:show', {
					type: 'error',
					title: 'Navigation Error',
					message: 'Failed to save selections or redirect.',
					duration: 3000,
				});
			}
		},
	},
	mounted() {
		// With mock data, this block is no longer strictly needed for rendering.
		// However, it's good practice to keep it for when you connect to a real API.	
		console.log('Selected Product:', this.selectQuotationResults[0].reccommendations[0]
		);
		console.log('Selected Cover Type:', this.selectedCoverType);
	
		console.log('Final Premium:', this.finalPremium);
		console.log(
			'Is Third Party:',
			this.selectedCoverType === 'third-party',
		);
		this.calculatePremium()
		// console.log("==benefitCalculation", this.getBenefitCalculation())
		const ref = this.$route.params.ref || this.$route.params.quotationID;
		if (ref) {
			try {
				// This would be the real API call
				// await this.viewClientRecommendation(ref);
			} catch (error) {
				console.error(
					'Error in mounted while fetching recommendation:',
					error,
				);
			}
		}
	},
};
</script>

<style lang="less" scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');

@primary-color: #2563eb;
@primary-hover: #1d4ed8;
@success-color: #059669;
@danger-color: #dc2626;
@warning-color: #d97706;
@info-color: #0891b2;
@light-bg: #f8fafc;
@white: #ffffff;
@gray-50: #f9fafb;
@gray-100: #f3f4f6;
@gray-200: #e5e7eb;
@gray-300: #d1d5db;
@gray-400: #9ca3af;
@gray-500: #6b7280;
@gray-600: #4b5563;
@gray-700: #374151;
@gray-800: #1f2937;
@gray-900: #111827;

.quotation-details-container {
	min-height: 100vh;
	min-width:full;
	background: linear-gradient(135deg, @light-bg 0%, #e2e8f0 100%);
	font-family:
		'Inter',
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		sans-serif;
}

.quotation-header {
	background: @white;
	border-bottom: 1px solid @gray-200;
	padding: 2rem 0 1.5rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

	.header-content {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
	.status-accepted {
		background:@success-color
	}

	.header-title-section {
		.page-title {
			font-size: 2rem;
			font-weight: 700;
			color: @gray-900;
			margin: 0 0 0.5rem 0;
			line-height: 1.2;
		}

		.page-subtitle {
			font-size: 1.125rem;
			color: @gray-600;
			margin: 0;
			font-weight: 400;
		}
	}
}

.main-content {
	padding: 2rem 0;

	.content-grid {
		display: grid;
		gap: 2rem;
		grid-template-columns: 1fr;

		@media (min-width: 1024px) {
			grid-template-columns: 400px 1fr;
		}
	}
}

.right-column-wrapper {
	display: flex;
	flex-direction: column;
	gap: 2rem;
}

.summary-card,
.product-details-card,
.benefits-and-premium-card,
.risks-section {
	background: @white;
	border-radius: 16px;
	box-shadow:
		0 4px 6px rgba(0, 0, 0, 0.05),
		0 1px 3px rgba(0, 0, 0, 0.1);
	overflow: hidden;

	.card-content {
		padding: 2rem;
	}

	.section-title {
		font-size: 1.5rem;
		font-weight: 700;
		color: @gray-900;
		margin: 0 0 1rem 0;
	}

	.section-subtitle {
		font-size: 1rem;
		color: @gray-600;
		margin: 0 0 1.5rem 0;
		line-height: 1.6;
	}
}

.summary-card {
	position: sticky;
	top: 2rem;
	height: fit-content;

	.summary-header {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		gap: 1rem;
		margin-bottom: 1.5rem;
	}

	.status-badge {
		display: inline-flex;
		align-items: center;
		gap: 0.5rem;
		padding: 0.5rem 1rem;
		border-radius: 20px;
		font-size: 0.875rem;
		font-weight: 600;
		text-transform: capitalize;

		.status-icon {
			font-size: 0.75rem;
		}

		&.status-pending {
			background: #fef3c7;
			color: #92400e;
		}
		&.status-approved {
			background: #d1fae5;
			color: #065f46;
		}
		&.status-rejected {
			background: #fee2e2;
			color: #991b1b;
		}
		&.status-processing {
			background: #dbeafe;
			color: #1e40af;
		}
		&.status-default {
			background: @gray-100;
			color: @gray-700;
		}
	}

	.summary-details {
		.detail-grid {
			display: grid;
			gap: 1.5rem;
			margin-bottom: 1.5rem;
		}

		.detail-item {
			.detail-label {
				display: flex;
				align-items: center;
				gap: 0.5rem;
				font-size: 0.875rem;
				font-weight: 600;
				color: @gray-700;
				margin-bottom: 0.5rem;

				.detail-icon {
					color: @primary-color;
					font-size: 0.875rem;
				}
			}

			.detail-value {
				font-size: 1rem;
				color: @gray-900;
				font-weight: 500;
			}
		}

		.remarks-section {
			padding: 1.5rem;
			background: @gray-50;
			border-radius: 12px;
			border-left: 4px solid @primary-color;

			.detail-label {
				display: flex;
				align-items: center;
				gap: 0.5rem;
				font-weight: 600;
				color: @gray-700;
				margin-bottom: 0.75rem;
			}

			.remarks-content {
				font-size: 0.875rem;
				color: @gray-700;
				line-height: 1.6;
				margin: 0;
			}
		}
	}

	.summary-actions {
		border-top: 1px solid @gray-200;
		padding-top: 1.5rem;

		.accept-btn {
			width: 100%;
			padding: 0.75rem 1.5rem;
			background: @success-color;
			border: 2px solid @primary-color;
			color: @white;
			font-weight: 600;
			border-radius: 8px;
			transition: all 0.2s ease;

			&:hover {
				background: @primary-hover;
				border-color: @primary-hover;
				transform: translateY(-1px);
				box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
			}

			i {
				margin-right: 0.5rem;
			}
		}
	}
}

.product-details-card {
	.product-grid {
		display: grid;
		gap: 1.5rem;
		grid-template-columns: 120px 1fr;

		@media (max-width: 768px) {
			grid-template-columns: 1fr;
		}
	}

	.product-image {
		.profile-img {
			width: 100px;
			height: 100px;
			object-fit: cover;
			border-radius: 12px;
			border: 1px solid @gray-200;
		}
	}

	.product-info {
		.detail-item {
			margin-bottom: 1.5rem;

			.detail-label {
				font-size: 0.875rem;
				font-weight: 600;
				color: @gray-700;
				margin-bottom: 0.5rem;
			}

			.detail-value {
				font-size: 1rem;
				color: @gray-900;
				font-weight: 500;
			}

			.star-rating {
				display: flex;
				align-items: center;
				gap: 0.75rem;

				.fa-star {
					font-size: 0.875rem;
					&.filled {
						color: #fbbf24;
					}
					&.empty {
						color: @gray-300;
					}
				}

				.level-text {
					font-size: 0.875rem;
					color: @primary-color;
					font-weight: 600;
				}
			}
		}
	}
}

.benefits-and-premium-card {
	.benefits-section {
		.section-header {
			border-bottom: 1px solid @gray-200;
			padding-bottom: 1.5rem;
			margin-bottom: 1.5rem;
		}

		.table {
			.form-control-sm {
				width: 120px;
				border-radius: 8px;
				border: 1px solid @gray-300;
				padding: 0.5rem;
				font-size: 0.875rem;

				&:focus {
					border-color: @primary-color;
					box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
				}
			}

			.form-check-input {
				width: 1.25rem;
				height: 1.25rem;
				border-radius: 4px;
				border: 1px solid @gray-300;

				&:checked {
					background-color: @primary-color;
					border-color: @primary-color;
				}
			}

			th,
			td {
				padding: 1rem;
				font-size: 0.875rem;
				color: @gray-700;
			}

			th {
				font-weight: 600;
				color: @gray-900;
			}
		}

		.benefits-list {
			display: flex;
			flex-direction: column;
			gap: 1.5rem;

			.benefit-item {
				border: 1px solid @gray-200;
				border-radius: 12px;
				padding: 1.5rem;
				transition: all 0.2s ease;

				&:hover {
					box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
				}

				.item-header {
					display: flex;
					justify-content: space-between;
					align-items: flex-start;
					margin-bottom: 1rem;
					gap: 1rem;

					.item-type {
						font-size: 0.75rem;
						font-weight: 600;
						padding: 0.25rem 0.75rem;
						border-radius: 20px;

						&.embedded-badge {
							background-color: #dbeafe;
							color: #1e40af;
						}

						&.optional-badge {
							background-color: #e5e7eb;
							color: @gray-700;
						}
					}
				}

				.item-details {
					display: grid;
					grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
					gap: 1rem;

					.detail-row {
						display: flex;
						flex-direction: column;
						gap: 0.5rem;

						.detail-label {
							font-size: 0.875rem;
							color: @gray-500;
							font-weight: 500;
						}

						.detail-value {
							font-size: 0.875rem;
							color: @gray-900;
							font-weight: 600;
						}

						.form-control-sm {
							width: 100%;
						}

						.form-check-input {
							align-self: flex-start;
							margin-top: 0.25rem;
						}
					}
				}
			}
		}
	}

	.premium-summary-section {
		border-top: 1px solid @gray-200;
		padding-top: 1.5rem;
		margin-top: 1.5rem;

		.premium-details {
			.detail-item {
				display: flex;
				justify-content: space-between;
				margin-bottom: 0.75rem;

				.detail-label {
					font-size: 0.875rem;
					color: @gray-700;
					font-weight: 500;

					&.fw-bold {
						color: @gray-900;
						font-weight: 700;
					}
				}

				.detail-value {
					font-size: 0.875rem;
					color: @gray-900;
					font-weight: 500;

					&.fw-bold {
						font-weight: 700;
					}
				}
			}

			hr {
				border-color: @gray-200;
				margin: 1rem 0;
			}
		}
	}

	.benefit-details {
		.benefit-name {
			font-size: 1rem;
			font-weight: 600;
			color: @gray-900;
			margin-bottom: 0.25rem;
		}

		.benefit-description {
			font-size: 0.875rem;
			color: @gray-600;
			line-height: 1.4;
			margin: 0;
		}
	}

	.benefit-header-content {
		flex: 1;

		.item-name {
			font-size: 1rem;
			font-weight: 600;
			color: @gray-900;
			display: block;
			margin-bottom: 0.25rem;
		}

		.item-description {
			font-size: 0.875rem;
			color: @gray-600;
			line-height: 1.4;
			margin: 0;
		}
	}
}

.risks-section {
	.risks-grid {
		display: grid;
		gap: 1rem;
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	}

	.risk-card {
		background: @gray-50;
		border-radius: 12px;
		border: 1px solid @gray-200;
		transition: all 0.3s ease;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		}

		.card-content {
			padding: 1rem;
			display: flex;
			align-items: center;
			gap: 0.75rem;

			.risk-icon {
				color: @primary-color;
				font-size: 1rem;
			}

			.risk-value {
				font-size: 0.875rem;
				color: @gray-900;
				font-weight: 500;
			}
		}
	}
}

.navigation-actions {
	padding: 1.5rem 0;
	display: flex;
	justify-content: flex-end;

	.next-btn {
		position: relative;
		overflow: hidden;
		width: 100%;
		padding: 0.75rem 1.5rem;
		background: @primary-color;
		border: 2px solid @primary-color;
		color: @white;
		font-weight: 600;
		border-radius: 8px;
		transition: all 0.2s ease;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1;

		&:hover {
			background: @primary-hover;
			border-color: @primary-hover;
			transform: translateY(-1px);
			box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
		}

		&.is-animating {
			pointer-events: none;
			background-color: @success-color;
			border-color: @success-color;

			span {
				opacity: 0;
				transition: opacity 0.5s ease-in-out;
			}
		}

		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: @primary-color;
			transform: translateX(-100%);
			transition: transform 0.5s ease-in-out;
			z-index: -1;
		}

		&.is-animating::after {
			transform: translateX(0);
		}
	}
}

.loading-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 3rem 2rem;
	text-align: center;

	.loading-spinner {
		margin-bottom: 1rem;

		.spinner {
			width: 40px;
			height: 40px;
			border: 3px solid @gray-200;
			border-top: 3px solid @primary-color;
			border-radius: 50%;
			animation: spin 1s linear infinite;
		}
	}

	.loading-text {
		color: @gray-600;
		font-size: 0.875rem;
		margin: 0;
	}
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

@media (max-width: 991px) {
	.quotation-header {
		padding: 1.5rem 0 1rem;

		.page-title {
			font-size: 1.5rem;
		}
		.page-subtitle {
			font-size: 1rem;
		}
	}

	.main-content {
		padding: 1rem 0;

		.content-grid {
			gap: 1.5rem;
		}
	}

	.summary-card {
		position: static;

		.card-content {
			padding: 1.5rem;
		}
	}

	.product-details-card {
		.product-grid {
			grid-template-columns: 1fr;
			.product-image {
				text-align: center;
				margin-bottom: 1rem;
			}
		}
		.product-info .detail-item {
			margin-bottom: 1rem;
		}
	}

	.benefits-and-premium-card {
		.benefits-section {
			.benefits-list {
				.benefit-item {
					.item-details {
						grid-template-columns: 1fr 1fr;
					}
				}
			}
		}

		.benefit-details {
			.benefit-name {
				font-size: 0.875rem;
			}

			.benefit-description {
				font-size: 0.8125rem;
			}
		}

		.benefit-header-content {
			.item-name {
				font-size: 0.875rem;
			}

			.item-description {
				font-size: 0.8125rem;
			}
		}

		.item-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 0.5rem;

			.item-type {
				align-self: flex-end;
			}
		}
	}

	.risks-section {
		.risks-grid {
			grid-template-columns: 1fr;
		}
		.risk-card .card-content {
			padding: 0.75rem;
			flex-direction: row;
			align-items: center;
			gap: 0.5rem;
			.risk-icon {
				font-size: 0.875rem;
			}
			.risk-value {
				font-size: 0.875rem;
			}
		}
	}

	.navigation-actions {
		.next-btn {
			width: 100%;
		}
	}
}
</style>
